// Copyright 2025, University of Maryland, All Rights Reserved
import { getWorkspacesApi } from '@/subsystems/workspaces/services/api'
import type { SiteBannerSettings, SiteBannerUpdateRequest } from '../types'

export type SiteBannerApi = ReturnType<typeof useSiteBannerApi>

export const useSiteBannerApi = () => {
  const api = getWorkspacesApi()

  return {
    getBanner: async (): Promise<SiteBannerSettings> => {
      const response = await api.get<SiteBannerSettings>('/site-banner')
      return response.data
    },

    updateBanner: async (data: SiteBannerUpdateRequest): Promise<SiteBannerSettings> => {
      const response = await api.put<SiteBannerSettings>('/admin/site-banner', data)
      return response.data
    },
  }
}
